import Unauthorized from '@/views/errors/403.vue';
import NotFound from '@/views/errors/404.vue';
import InternalServerError from '@/views/errors/500.vue';

export default [
  {
    path: '/403',
    name: 'Unauthorized',
    component: Unauthorized,
  },  
  {
    path: '/404',
    name: 'not-found',
    component: NotFound,
  },
  {
    path: '/500',
    name: 'internal-server-error',
    component: InternalServerError,
  },  
  {
    path: '/:pathMatch(.*)*',
    redirect: '/404',
  },
];
